export function sanitizeReturnTo(value: unknown): string | null {
  if (typeof value !== 'string' || value.length === 0) return null
  if (!value.startsWith('/')) return null
  if (value.startsWith('//')) return null
  const beforeQuery = value.split(/[?#]/, 1)[0]
  if (beforeQuery.includes(':')) return null
  return value
}
